import * as FPT from './fpt';
import TemplateData from './getTemplateData';

/**
 * Loads bodymovin and hearts animation json
 */
export function loadBodyMovin() {
  return Promise.all([
    import(
      /* webpackChunkName: 'bodymovin' */ 'bodymovin/build/player/bodymovin.min'
    ),
    import(/* webpackChunkName: 'hearts' */ '../vendor/hearts.json'),
  ]).catch((error) => {
    FPT.trackError({
      message: 'LAZY_LOAD_FAILED',
      code: 'bodymovin',
      error,
    });
  });
}

/**
 * Load Progressive Onboarding component (Full Bundle)
 */
export function loadProgressiveOnboarding() {
  return Promise.all([
    import(
      /* webpackChunkName: 'ProgressiveonboardingFull' */ 'portableonboarding/build/fullBundle'
    ),
  ]).catch((error) => {
    FPT.trackError({
      message: 'LAZY_LOAD_FAILED',
      code: 'progressive_full',
      error,
    });
  });
}

/**
 * Load Progressive Onboarding component (Slick Version)
 */
export function loadSlickProgressiveOnboarding() {
  return Promise.all([
    import(
      /* webpackChunkName: 'ProgressiveonboardingSlick' */ 'portableonboarding'
    ),
  ]).catch((error) => {
    FPT.trackError({
      message: 'LAZY_LOAD_FAILED',
      code: 'progressive_slick',
      error,
    });
  });
}

export function loadZoidScripts() {
  const scriptPath =
    'https://www.paypalobjects.com/donate/sdk/v0.1.0/donate-sdk.js';
  return loadScript(scriptPath).catch((error) => {
    FPT.trackError({
      message: 'LAZY_LOAD_FAILED',
      code: 'zoid_button_scipt',
      error,
    });
  });
}

function loadScript(scriptPath) {
  return new Promise((resolve, reject) => {
    const nonce = TemplateData.nonce;
    var script = document.createElement('script');
    script.src = scriptPath;
    script.nonce = nonce;
    script.onload = function (params) {
      resolve(params);
    };
    script.onerror = function (params) {
      reject(params);
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}
